module.exports = __webpack_public_path__ + "static/media/yuanjing.860d479a.jpg";